(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3256],{

/***/ 7885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/node_modules/react-is/index.js
var react_is = __webpack_require__(65122);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/BreadcrumbCollapsed.js









var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes"]);

  return /*#__PURE__*/react.createElement(ButtonBase/* default */.Z, (0,esm_extends/* default */.Z)({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/react.createElement(MoreHoriz, {
    className: classes.icon
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js










var Breadcrumbs_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/react.createElement("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = react.useState(false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}

      return allItems;
    }

    return [].concat((0,toConsumableArray/* default */.Z)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/react.createElement(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], (0,toConsumableArray/* default */.Z)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = react.Children.toArray(children).filter(function (child) {
    if (false) {}

    return /*#__PURE__*/react.isValidElement(child);
  }).map(function (child, index) {
    return /*#__PURE__*/react.createElement("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/react.createElement(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other), /*#__PURE__*/react.createElement("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = ((0,withStyles/* default */.Z)(Breadcrumbs_styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));

/***/ }),

/***/ 40341:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 65122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(40341);
} else {}


/***/ }),

/***/ 19495:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessibility",
      function () {
        return __webpack_require__(68641);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 97294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ StyledHeaderSubtitle; },
/* harmony export */   "$v": function() { return /* binding */ StyledTh; },
/* harmony export */   "EF": function() { return /* binding */ StyledLi; },
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "GI": function() { return /* binding */ StyledTd; },
/* harmony export */   "PW": function() { return /* binding */ StyledSmallText; },
/* harmony export */   "SG": function() { return /* binding */ StyledThead; },
/* harmony export */   "TK": function() { return /* binding */ StyledSubtitle; },
/* harmony export */   "ZN": function() { return /* binding */ StyledBody2; },
/* harmony export */   "aG": function() { return /* binding */ StyledTr; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "hc": function() { return /* binding */ StyledUl; },
/* harmony export */   "k6": function() { return /* binding */ StyledTable; },
/* harmony export */   "vc": function() { return /* binding */ StyledBody; },
/* harmony export */   "x0": function() { return /* binding */ StyledHeaderH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "px;\n  ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: ",
        "px;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  letter-spacing: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 40px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    max-width: 300px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  &::marker {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  ",
        ";\n  color: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-collapse: collapse;\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    display: block;\n    width: ",
        ";\n    overflow: auto;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: normal;\n  td:first-child {\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 7px 7px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: normal;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 5px;\n  border: 1px solid ",
        ";\n  font-size: 18px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var StyledHeaderH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "BodyText__StyledHeaderH2",
    componentId: "sc-d1eb1ea9-0"
})(_templateObject(), function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin);
}, function(p) {
    return p.$lineHeight && "line-height: ".concat(p.$lineHeight);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "24px";
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "400";
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSubtitle",
    componentId: "sc-d1eb1ea9-1"
})(_templateObject1(), function(p) {
    return p.$margin;
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "bold";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledHeaderSubtitle",
    componentId: "sc-d1eb1ea9-2"
})(_templateObject2(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "20px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
});
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "BodyText__StyledBody",
    componentId: "sc-d1eb1ea9-3"
})(_templateObject3(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "18px";
});
var StyledH3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledH3",
    componentId: "sc-d1eb1ea9-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledUl = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "BodyText__StyledUl",
    componentId: "sc-d1eb1ea9-5"
})(_templateObject5(), function(p) {
    return p.$padding && "padding-right: ".concat(p.$padding, "px");
});
var StyledLi = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "BodyText__StyledLi",
    componentId: "sc-d1eb1ea9-6"
})(_templateObject6(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0px";
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "BodyText__StyledLink",
    componentId: "sc-d1eb1ea9-7"
})(_templateObject7(), function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
}, function(p) {
    return p.$color ? p.$color : p.theme.colors.mazdaRed;
}, function(p) {
    return p.$display && "display: ".concat(p.$display);
}, function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
});
var StyledSmallText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSmallText",
    componentId: "sc-d1eb1ea9-8"
})(_templateObject8(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$fontWeight && "font-weight: ".concat(p.$fontWeight);
});
var StyledBody2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BodyText__StyledBody2",
    componentId: "sc-d1eb1ea9-9"
})(_templateObject9(), function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "BodyText__StyledTable",
    componentId: "sc-d1eb1ea9-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$width ? p.$width : "350px";
}, function(p) {
    return p.theme.breakpoints.down("xs");
}, function(p) {
    return p.$width ? p.$width : "90vw";
});
var StyledThead = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
    displayName: "BodyText__StyledThead",
    componentId: "sc-d1eb1ea9-11"
})(_templateObject11());
var StyledTr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    displayName: "BodyText__StyledTr",
    componentId: "sc-d1eb1ea9-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "BodyText__StyledTh",
    componentId: "sc-d1eb1ea9-13"
})(_templateObject13(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    displayName: "BodyText__StyledTd",
    componentId: "sc-d1eb1ea9-14"
})(_templateObject14(), function(p) {
    return p.theme.colors.darkGrey;
});


/***/ }),

/***/ 86040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StyledHeaderH1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: ",
        ";\n  margin-top: ",
        ";\n  word-break: ",
        ';\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    text-align: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: 20px;\n  font-weight: 300;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 20px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 27px;\n  color: ',
        ";\n  width: ",
        ";\n  margin: auto;\n  ",
        ";\n  ",
        " {\n    text-align: right;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 0.5px;\n  background-color: ",
        ";\n  margin-top: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledCenterText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledCenterText",
    componentId: "sc-cd579a81-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h1"
}).withConfig({
    displayName: "CenterText__StyledHeaderH1",
    componentId: "sc-cd579a81-1"
})(_templateObject1(), function(p) {
    return p.$margin ? "center" : "center";
}, function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0";
}, function(p) {
    return p.$break && p.$break;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$align ? p.$align : "right";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "CenterText__StyledHeaderSubtitle",
    componentId: "sc-cd579a81-2"
})(_templateObject2());
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CenterText__StyledBody",
    componentId: "sc-cd579a81-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.$page === "color" ? "500px" : "985px";
}, function(p) {
    return p.$margin && "margin-top: 20px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLine = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledLine",
    componentId: "sc-cd579a81-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledFooterText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "CenterText__StyledFooterText",
    componentId: "sc-cd579a81-5"
})(_templateObject5());
var CenterText = function(param) {
    var title = param.title, subtitle = param.subtitle, headerText = param.headerText, footerText = param.footerText, withBorder = param.withBorder, margin = param.margin, page = param.page;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCenterText, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderH1, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderSubtitle, {
                children: subtitle
            }),
            headerText.map(function(text) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBody, {
                    $margin: margin,
                    $page: page,
                    children: text
                }, text);
            }),
            footerText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooterText, {
                children: footerText
            }) : null,
            isDesktop && withBorder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLine, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CenterText);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 68641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ accessibility; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
// EXTERNAL MODULE: ./reusable/wrappers/CenterText.tsx
var CenterText = __webpack_require__(86040);
// EXTERNAL MODULE: ./reusable/wrappers/ImageContainer.tsx
var ImageContainer = __webpack_require__(63358);
;// CONCATENATED MODULE: ./components/pages/AccessibilityPage.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  max-width: 1160px;\n  ",
        " {\n    padding-right: 20px;\n    padding-left: 0px;\n    max-width: 100%;\n    width: 100%;\n    div,\n    p,\n    ul {\n      padding-left: 20px;\n    }\n    h2 {\n      width: 320px;\n    }\n    li {\n      width: 320px;\n      font-size: 18px;\n    }\n    a {\n      width: 250px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  background: ",
        ";\n  padding-bottom: 80px;\n  td:first-child {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin-top: ",
        "px;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #101010;\n  font-size: 18px;\n  font-family: MazdaType, OENaPro, sans-serif;\n  line-height: 150%;\n  text-decoration: underline;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  margin-top: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var StyledTextWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AccessibilityPage__StyledTextWrapp",
    componentId: "sc-cfb0d68a-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AccessibilityPage__StyledPageDiv",
    componentId: "sc-cfb0d68a-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.lightGrey;
});
var StyledH2 = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "AccessibilityPage__StyledH2",
    componentId: "sc-cfb0d68a-2"
})(_templateObject2(), function(p) {
    return p.$fontSize ? p.$fontSize : "20px";
}, function(p) {
    return p.$margin && p.$margin;
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "bold";
});
var StyledHyperlink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "AccessibilityPage__StyledHyperlink",
    componentId: "sc-cfb0d68a-3"
})(_templateObject3());
var StyledSmallTextP = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "AccessibilityPage__StyledSmallTextP",
    componentId: "sc-cfb0d68a-4"
})(_templateObject4());
var AccessibilityPage = function() {
    var headerText = [
        'דלק מוטורס בע"מ משקיעה מאמצים ומשאבים רבים כדי לספק שירות נגיש, שוויוני ומכבד לכל אחד ואחת מהלקוחות שלנו. \vבהתאם לחוק שוויון זכויות לאנשים עם מוגבלות תשנ״ח-1998, ביצענו התאמות נגישות באולמות התצוגה שלנו כדי לאפשר לכל אדם לקבל שירות שוויוני ברמה הגבוהה ביותר. כאן ניתן להתעדכן בהסדרי הנגישות בכל אולם', 
    ];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledPageWrapper */.S0, {
        $padding: "0px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer/* default */.Z, {
                    src: isDesktop ? "/img/accessibility.jpg" : "/img/accessibilityMobile.jpg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    name: "Accessibility"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterText/* default */.Z, {
                            title: "הצהרת נגישות",
                            headerText: headerText,
                            withBorder: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                            $margin: 40,
                            children: "הסדרי נגישות מבנים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledSmallText */.PW, {
                            children: "להלן הסדרי הנגישות הקיימים במרכזי קבלת קהל"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTable */.k6, {
                            $width: "auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledThead */.SG, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "190px"
                                                },
                                                children: "מרכזי קבלת קהל"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "260px"
                                                },
                                                children: "כתובת"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "109px"
                                                },
                                                children: "מצב נגישות"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "105px"
                                                },
                                                children: "חניות נכים"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "150px"
                                                },
                                                children: "שירותים נגישים"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "122px"
                                                },
                                                children: "שילוט הכוונה"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "משרדי החברה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "א.ת ניר צבי"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "מוסך מרכזי"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "א.ת ניר צבי"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "אולם מאזדה חיפה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "שד׳ הסתדרות 50, חיפה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "אולם מאזדה ירושלים"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח׳ פייר קניג 40, ירושלים"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "אולם מאזדה רעננה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח׳ תדהר 2, רעננה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "אולם מאזדה ת״א"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח׳ החרש 20, ת״א"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledSmallText */.PW, {
                            $margin: 40,
                            children: "להלן הסדרי הנגישות הקיימים בסוכנויות המשנה"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTable */.k6, {
                            $width: "auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledThead */.SG, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "190px"
                                                },
                                                children: "מרכזי קבלת קהל"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "260px"
                                                },
                                                children: "כתובת"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "109px"
                                                },
                                                children: "מצב נגישות"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "105px"
                                                },
                                                children: "חניות נכים"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "150px"
                                                },
                                                children: "שירותים נגישים"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTh */.$v, {
                                                style: {
                                                    minWidth: "122px"
                                                },
                                                children: "שילוט הכוונה"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "מאזדה נצרת"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח' פאולוס השישי 42, נצרת"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "בהליך הנגשה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "מאזדה חיפה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח' יפו 124, חיפה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "מאזדה נתניה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח' דוד פנקס 36, נתניה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "מאזדה אשדוד"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח' הורגנים 11, אשדוד"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledTr */.aG, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "אולם מאזדה באר-שבע"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "רח' עמל 2, באר שבע"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "בהליך הנגשה"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledTd */.GI, {
                                            children: "נגיש"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                            $margin: 40,
                            children: "מרכזי שירות"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: "מרכזי השירות הם גופים עצמאיים האחראים לעמידה בדרישות הנגישות של מתקניהם ואתריהם. על לקוח עם מוגבלות המבקש לקבל שירות במרכז שירות מסוים, ליצור קשר עם מרכז השירות לקבלת מידע בנושא הנגישות"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                            $margin: 40,
                            children: "שירות לקוחות נגיש"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledSmallText */.PW, {
                            $margin: 20,
                            children: "הדרכות עובדים לשירות נגיש"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: "מתקיימות הדרכות להכרת תחום הנגישות, יצירת מודעות בקרב העובדים והקניית כלים מעשיים למתן שירות נגיש."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledSmallText */.PW, {
                            $margin: 20,
                            children: "מוקד טלפוני נגיש "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: "המענה הקולי הונגש כך שהמידע מועבר בשפה ברורה וללא מוסיקת רקע."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledSmallText */.PW, {
                            $margin: 20,
                            children: "אמצעים נוספים ליצירת קשר"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                            children: [
                                "דוא״ל:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                    href: "mailto: s.uzon@delekmotors.co.il",
                                    $color: "#4C607E",
                                    $fontSize: 18,
                                    children: "s.uzon@delekmotors.co.il"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                            children: [
                                'פניה באמצעות "צור קשר" באתר. לנוחיותכם לינק',
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHyperlink, {
                                    href: "contact-us",
                                    children: "לטופס פנייה"
                                }),
                                " ",
                                ">"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: "פניה באמצעות הדואר: אזור תעשייה מושב ניר צבי, ת.ד 200, 7290500"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                            $margin: 40,
                            children: "נגישות אתר האינטרנט"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: ' אתר אינטרנט נגיש הוא אתר המאפשר לאנשים עם מוגבלות ולאנשים מבוגרים\n            לגלוש באותה רמה של יעילות והנאה ככל הגולשים, כ- 20 עד 25 אחוזים\n            מהאוכלוסייה נתקלים בקשיי שימוש באינטרנט ועשויים להיטיב מתכני אינטרנט\n            נגישים יותר, כך על פי מחקר שנערך בשנת 2003 ע"י חברת מייקרוסופט. חברת\n            דלק מוטורס בע"מ מאמינה ופועלת למען שוויון הזדמנויות במרחב האינטרנטי\n            לבעלי לקויות מגוונות ואנשים הנעזרים בטכנולוגיה מסייעת לשימוש במחשב.'
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledSubtitle */.TK, {
                            $margin: 20,
                            $fontWeight: "300",
                            children: "מידע על נגישות האתר"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                            $padding: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: 'אתר זה עומד בדרישות תקנות שיוויון זכויות לאנשים עם מוגבלות (התאמות\n              נגישות לשירות), התשע"ג 2013.'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: [
                                        "התאמות הנגישות בוצעו ",
                                        'עפ"י',
                                        " המלצות התקן הישראלי ",
                                        '(ת"י 5568)',
                                        " ",
                                        "לנגישות תכנים באינטרנט ברמת AA ומסמך ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "WCAG2.0 הבינלאומי."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: "הבדיקות נבחנו לתאימות הגבוהה ביותר עבור דפדפן כרום."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: "האתר מספק מבנה סמנטי עבור טכנולוגיות מסייעות ותמיכה בדפוס השימוש המקובל להפעלה עם מקלדת בעזרת מקשי החיצים, Enter ו- Esc ליציאה מתפריטים וחלונות."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: "מותאם לתצוגה בדפדפנים הנפוצים ולשימוש בטלפון הסלואלרי."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: "לשם קבלת חווית גלישה מיטבית עם תוכנת הקראת מסך, אנו ממליצים לשימוש בתוכנת NVDA העדכנית ביותר."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: "מסמכים או סרטוני וידאו שעלו לאתר לפני אוקטובר 2017 ייתכן שלא נגישים באופן מלא. במידה שנתקלתם במסמך כזה או בסרטון, תוכלו לפנות לרכזת נגישות בחברה ואנחנו נדאג להנגיש לכם את המידע."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                    $margin: 20,
                                    children: "מסירת מידע בפורמט נגיש - החברה מעמידה עבור לקוחותיה אפשרות לקבלת מידע בפורמטים נגישים. מסירת המידע הינה ללא עלות ומיועדת עבור אנשים עם מוגבלות. לפניותומידע בנושא נגישות ניתן ליצור קשר עם רכז הנגישות של החברה שפרטיו מופיעים בהמשך ההצהרה."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                            href: "https://a-2-z.co.il/",
                            $margin: 20,
                            $display: "block",
                            $color: "#4C607E",
                            $fontSize: 18,
                            children: "בדיקות ויעוץ הנגישות בוצעו על ידי חברת A2Z נגישות ושיווק באינטרנט"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                            $margin: 40,
                            children: "דרכי פנייה לבקשות והצעות לשיפור בנושא נגישות"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: "יש לציין כי אנו ממשיכים במאמצים לשפר את נגישות החברה כחלק ממחויבותנו לאפשר לכלל האוכלוסייה כולל אנשים עם מוגבלויות לקבל את השרות הנגיש ביותר."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: "במידה ונתקלת בבעיה או בתקלה כלשהי בנושא הנגישות, נשמח שתעדכן אותנו בכך ואנו נעשה כל מאמץ למצוא עבורך פתרון מתאים ולטפל בתקלה בהקדם ככל שניתן."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2, {
                            $margin: 40,
                            $fontWeight: "300",
                            children: 'פרטי רכז הנגישות בדלק מוטורס בע"מ'
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSmallTextP, {
                            children: "שם: שימי עוזון"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                            children: [
                                "טלפון:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                    href: "tel: 08-9139976",
                                    $color: "#4C607E",
                                    $fontSize: 16,
                                    children: "08-9139976"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                            children: [
                                "דוא”ל:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                    href: "mailto: s.uzon@delekmotors.co.il",
                                    $color: "#4C607E",
                                    $fontSize: 16,
                                    children: "s.uzon@delekmotors.co.il"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2, {
                            $fontSize: "18px",
                            $fontWeight: "300",
                            children: "פרסום הצהרת הנגישות"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                            children: "הצהרת הנגישות עודכנה ביום: 23.06.2024"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var pages_AccessibilityPage = (AccessibilityPage);

;// CONCATENATED MODULE: ./src/pages/accessibility.tsx



var Accessibility = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_AccessibilityPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var accessibility = (Accessibility);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(19495); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);